import CasePropertiesProviderModule from "./CasePropertiesProvider";

const CaseModule = {
  __init__: [ 'casePropertiesProvider' ],
  casePropertiesProvider: [ 'type', CasePropertiesProviderModule ]
};

export default CaseModule;